module.exports = __webpack_public_path__ + "static/media/mmi-iso-9001-zertifikat.0edade68.pdf";